export default "__VITE_ASSET__3f6b3b97__"